"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEnvVarWithOverride = exports.createOverrideEnvVar = exports.overrideEnvVar = exports.createGetEnvVarWithOverride = exports.getEnvVarWithOverride = exports.createGetEnvVar = exports.getEnvVar = exports.setEnvironment = exports.getEnvironment = void 0;

var window_1 = require("./window");

var overrides = {};
var canaryEnvs = ['staging', 'staging-app', 'stg.dashboard', 'integration', 'integration-app', 'registration-stg'];

var isCanaryEnvironment = function isCanaryEnvironment() {
  var _a, _b; // Return true for review apps and the `canaryEnvs`


  return ((_b = (_a = window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.location) === null || _a === void 0 ? void 0 : _a.host) === null || _b === void 0 ? void 0 : _b.includes('dev.hopininternal')) || canaryEnvs.some(function (canaryEnv) {
    var _a, _b;

    return (_b = (_a = window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.location) === null || _a === void 0 ? void 0 : _a.host) === null || _b === void 0 ? void 0 : _b.includes("".concat(canaryEnv, ".hopin"));
  });
};

var environmentKey = 'hopin-constants-environment';

var getEnvironment = function getEnvironment() {
  var _a, _b;

  return (window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.localStorage.getItem(environmentKey)) || isCanaryEnvironment() ? 'canary' : ((_b = (_a = window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.location) === null || _a === void 0 ? void 0 : _a.host) === null || _b === void 0 ? void 0 : _b.includes('localhost')) ? 'development' : 'production';
};

exports.getEnvironment = getEnvironment;

var setEnvironment = function setEnvironment(environment) {
  return window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.localStorage.setItem(environmentKey, environment);
};

exports.setEnvironment = setEnvironment;

var getEnvVar = function getEnvVar(source) {
  if (typeof source === 'function') {
    return source();
  }

  if (_typeof(source) === 'object') {
    return source[(0, exports.getEnvironment)()];
  }

  return source;
};

exports.getEnvVar = getEnvVar;

var createGetEnvVar = function createGetEnvVar(source) {
  return function () {
    return (0, exports.getEnvVar)(source);
  };
};

exports.createGetEnvVar = createGetEnvVar;

var getEnvVarWithOverride = function getEnvVarWithOverride(source, overrideName) {
  if (overrideName) {
    if (typeof window !== 'undefined') {
      var value = window.localStorage.getItem(overrideName);
      if (value) return value;
    } else {
      var value = overrides[overrideName];
      if (value) return value;
    }
  }

  return (0, exports.getEnvVar)(source);
};

exports.getEnvVarWithOverride = getEnvVarWithOverride;

var createGetEnvVarWithOverride = function createGetEnvVarWithOverride(source, overrideName) {
  return function () {
    return (0, exports.getEnvVarWithOverride)(source, overrideName);
  };
};

exports.createGetEnvVarWithOverride = createGetEnvVarWithOverride;

var overrideEnvVar = function overrideEnvVar(overrideName, value) {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(overrideName, value);
  } else {
    overrides[overrideName] = value;
  }
};

exports.overrideEnvVar = overrideEnvVar;

var createOverrideEnvVar = function createOverrideEnvVar(overrideName) {
  return function (value) {
    return (0, exports.overrideEnvVar)(overrideName, value);
  };
};

exports.createOverrideEnvVar = createOverrideEnvVar;

var createEnvVarWithOverride = function createEnvVarWithOverride(source, overrideName) {
  return {
    get: (0, exports.createGetEnvVarWithOverride)(source, overrideName),
    set: (0, exports.createOverrideEnvVar)(overrideName)
  };
};

exports.createEnvVarWithOverride = createEnvVarWithOverride;